import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function OrderSuccess() {
  const { t } = useTranslation();
  const location = useLocation();
  const orderId = new URLSearchParams(location.search).get('order_id');

  useEffect(() => {
    localStorage.removeItem('orderFormData');
    if (orderId) {
      fetch(`${process.env.REACT_APP_EXPRESS_URL}/api/order/mark-paid`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_id: orderId }),
      });
    }
  }, [orderId]);

  return (
    <div className="p-8 text-center">
      <h1 className="text-3xl font-bold text-green-600">🎉 {t('order.success_title')}</h1>
      <p className="mt-4">{t('order.success_message')}</p>
      {orderId && (
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
          {t('order.orderIdLabel')}: <strong>{orderId}</strong>
        </p>
      )}
    </div>
  );
}
